    (function () { function r(e, n, t) { function o(i, f) { if (!n[i]) { if (!e[i]) { var c = "function" == typeof require && require; if (!f && c) return c(i, !0); if (u) return u(i, !0); var a = new Error("Cannot find module '" + i + "'"); throw a.code = "MODULE_NOT_FOUND", a } var p = n[i] = { exports: {} }; e[i][0].call(p.exports, function (r) { var n = e[i][1][r]; return o(n || r) }, p, p.exports, r, e, n, t) } return n[i].exports } for (var u = "function" == typeof require && require, i = 0; i < t.length; i++)o(t[i]); return o } return r })()({
        1: [function (require, module, exports) {
            "use strict";

            document.addEventListener('DOMContentLoaded', function () {
                // Load more products scripts for BYM All Products tab
                const loadMoreButton = document.querySelector('.js-bym-load-more');
                const mainTab = document.querySelector('.js-bym-products-grid-list');

                function updateLoadMoreVisibility() {
                    if (!loadMoreButton || !mainTab) return;
                    if (mainTab.classList.contains('active')) {
                        loadMoreButton.style.display = '';
                    } else {
                        loadMoreButton.style.display = 'none';
                    }
                }

                updateLoadMoreVisibility();


                if (loadMoreButton) {
                    loadMoreButton.addEventListener('click', function () {
                        const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
                        const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
                        const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));
                        console.log('[BYM Load More] Clicked.');
                        console.log(`[BYM Load More] Current page: ${currentPage}, Total pages: ${totalPages}, Next URL: ${nextPageUrl}`);
                        if (currentPage < totalPages) {
                            loadMoreButton.disabled = true;
                            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
                            loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';
                            fetch(nextPageUrl)
                                .then(response => response.text())
                                .then(data => {
                                    console.log('[BYM Load More] Fetched next page.');
                                    const parser = new DOMParser();
                                    const html = parser.parseFromString(data, 'text/html');
                                    const newItems = html.querySelectorAll('.bym--products__tab.js-bym-products-grid-list > *');
                                    const gridList = document.querySelector('.js-bym-products-grid-list');
                                    let appendedCount = 0;
                                    let skippedCount = 0;
                                    console.log(`[BYM Load More] Before append, grid has: ${gridList.querySelectorAll('.bym-product').length} products.`);
                                    console.log(`[BYM Load More] HTML contains: ${newItems.length} products.`);
                                    newItems.forEach(item => {
                                        const productHandle = item.getAttribute('data-product-handle');
                                        if (productHandle && gridList.querySelector(`[data-product-handle="${productHandle}"]`)) {
                                            skippedCount++;
                                            console.log(`[BYM Load More] Skipping duplicate: ${productHandle}`);
                                            return;
                                        }
                                        gridList.appendChild(item);
                                        appendedCount++;
                                    });
                                    console.log(`[BYM Load More] Appended: ${appendedCount}, Skipped: ${skippedCount}`);
                                    console.log(`[BYM Load More] After append, grid has: ${gridList.querySelectorAll('.bym-product').length} products.`);
                                    const newLoadMore = html.querySelector('.js-bym-load-more');
                                    if (newLoadMore) {
                                        const newCurrentPage = newLoadMore.getAttribute('data-current-page');
                                        loadMoreButton.setAttribute('data-next-url', newLoadMore.getAttribute('data-next-url'));
                                        loadMoreButton.setAttribute('data-current-page', newCurrentPage);
                                        console.log(`[BYM Load More] Updated pagination. New current page: ${newCurrentPage}`);
                                        if (parseInt(newCurrentPage) >= totalPages) {
                                            loadMoreButton.style.display = 'none';
                                            console.log('[BYM Load More] Reached last page, hiding button.');
                                        } else {
                                            loadMoreButton.disabled = false;
                                            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
                                            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
                                        }
                                    } else {
                                        loadMoreButton.style.display = 'none';
                                        console.log('[BYM Load More] No more pages to load, hiding button.');
                                    }
                                })
                                .catch(error => {
                                    console.error('[BYM Load More] Error loading more products:', error);
                                    loadMoreButton.disabled = false;
                                    loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
                                    loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
                                });
                        } else {
                            loadMoreButton.style.display = 'none';
                            console.log('[BYM Load More] No more pages to load, hiding button.');
                        }
                    });
                }

                // Listen for tab switches and update Load More visibility
                document.body.addEventListener('click', function (e) {
                    const navItemBtn = e.target.closest('.bym--nav__item-btn');
                    if (navItemBtn) {
                        setTimeout(updateLoadMoreVisibility, 10);
                    }
                });

                // Scroll to top button functionality
                const scrollTopBtn = document.querySelector('.bym--nav__scroll-top-btn');
                const bymSection = document.querySelector('.bym');

                if (scrollTopBtn) {
                    scrollTopBtn.addEventListener('click', function () {
                        bymSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    });
                }
            });

            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = void 0;
            // Helper to get to a given parent
            const getClosest = function (elem, selector) {
                // Element.matches() polyfill
                if (!Element.prototype.matches) {
                    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) { }
                        return i > -1;
                    };
                }

                // Get the closest matching element
                for (; elem && elem !== document; elem = elem.parentNode) {
                    if (elem.matches(selector)) return elem;
                }
                return null;
            };
            var _default = getClosest;
            exports.default = _default;
        }, {}], 2: [function (require, module, exports) {
            "use strict";

            var _getClosest = _interopRequireDefault(require("../modules/getClosest"));
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            // Helper to load Swiper assets only once
            let swiperLoaded = false;
            function loadSwiperAssets(callback) {
                if (swiperLoaded) return callback();
                // Load CSS
                if (!document.querySelector('link[data-swiper]')) {
                    const link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css';
                    link.setAttribute('data-swiper', 'true');
                    document.head.appendChild(link);
                }
                // Load JS
                if (!window.Swiper) {
                    const script = document.createElement('script');
                    script.src = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';
                    script.onload = function () {
                        swiperLoaded = true;
                        callback();
                    };
                    document.body.appendChild(script);
                } else {
                    swiperLoaded = true;
                    callback();
                }
            }
            function initSwiperForTab(tab) {
                if (tab.getAttribute('data-swiper-initialized')) return;

                // Mobile slider
                const mobileSlider = tab.querySelector('.js-mobile-slider');
                let galleryMobile = null;
                if (mobileSlider && window.Swiper) {
                    galleryMobile = new window.Swiper(mobileSlider, {
                        slidesPerView: 1,
                        // Only one slide visible at a time
                        centeredSlides: true,
                        // No centering
                        loop: false,
                        pagination: {
                            el: tab.querySelector('.swiper-pagination'),
                            clickable: true
                        }
                    });
                }

                // Thumbs slider
                const thumbsSlider = tab.querySelector('.js-thumbs-slider');
                let galleryThumbs = null;
                if (thumbsSlider && window.Swiper) {
                    galleryThumbs = new window.Swiper(thumbsSlider, {
                        centeredSlides: false,
                        centeredSlidesBounds: true,
                        slidesPerView: 3,
                        watchOverflow: true,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                        direction: 'horizontal'
                    });
                }

                // Main slider
                const mainSlider = tab.querySelector('.js-main-slider');
                if (mainSlider && window.Swiper) {
                    const galleryMain = new window.Swiper(mainSlider, {
                        watchOverflow: true,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                        preventInteractionOnTransition: true,
                        slidesPerView: 1,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        thumbs: galleryThumbs ? {
                            swiper: galleryThumbs
                        } : undefined,
                        navigation: {
                            nextEl: tab.querySelector('.swiper-button-next'),
                            prevEl: tab.querySelector('.swiper-button-prev')
                        }
                    });
                    if (galleryThumbs) {
                        galleryMain.on('slideChangeTransitionStart', function () {
                            galleryThumbs.slideTo(galleryMain.activeIndex);
                        });
                        galleryThumbs.on('transitionStart', function () {
                            galleryMain.slideTo(galleryThumbs.activeIndex);
                        });
                    }
                }
                tab.setAttribute('data-swiper-initialized', 'true');
            }

            // Learn More popup
            document.addEventListener('DOMContentLoaded', function () {

                document.body.addEventListener('click', function (e) {

                    const toggleBtn = e.target.closest('.bym-product__toggle');
                    const closeBtn = e.target.closest('.bym-product__close');
                    const submitBtn = e.target.closest('.bym-form__submit');

                    const clickedProduct = e.target.closest('.bym-product');

                    // OPEN / TOGGLE
                    if (toggleBtn) {
                        const product = toggleBtn.closest('.bym-product');

                        // Optional: close all others first
                        document.querySelectorAll('.bym-product.is-tab-open')
                            .forEach(p => {
                                if (p !== product) p.classList.remove('is-tab-open');
                            });

                        product?.classList.toggle('is-tab-open');
                        return;
                    }

                    // CLOSE via explicit close button
                    if (closeBtn) {
                        closeBtn.closest('.bym-product')
                            ?.classList.remove('is-tab-open');
                        return;
                    }

                    // CLOSE on submit
                    if (submitBtn) {
                        submitBtn.closest('.bym-product')
                            ?.classList.remove('is-tab-open');
                        return;
                    }

                    // CLOSE IF CLICKED ANYWHERE OUTSIDE ANY BYM PRODUCT
                    if (!clickedProduct) {
                        document.querySelectorAll('.bym-product.is-tab-open')
                            .forEach(p => p.classList.remove('is-tab-open'));
                    }

                });

            });


            // Escape key closes all open tabs
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' || e.key === 'Esc') {
                    document.querySelectorAll('.bym-product.is-tab-open').forEach(p => p.classList.remove('is-tab-open'));
                }
            });


            document.addEventListener('DOMContentLoaded', function () {
                document.body.addEventListener('click', function (e) {
                    // Tab Description Toggle
                    const descToggle = e.target.closest('.bym-product__tab-description-toggle');
                    if (descToggle) {
                        const descWrap = descToggle.closest('.bym-product__tab-description-wrap');
                        if (descWrap) {
                            descWrap.classList.toggle('description-active');
                        }
                        return;
                    }
                    // BYM NAV TOGGLE THIS WORKS
                    const navToggle = e.target.closest('.js-bym-nav-toggle');
                    if (navToggle) {
                        const nav = document.querySelector('.js-bym-nav');
                        const navWrap = document.querySelector('.bym--nav');
                        if (nav) {
                            nav.classList.toggle('is-active');
                            if (nav.classList.contains('is-active')) {
                                if (navWrap) navWrap.classList.add('is-open');
                            } else {
                                if (navWrap) navWrap.classList.remove('is-open');
                            }
                        }
                        return;
                    }
                    // BYM Nav Close
                    const navClose = e.target.closest('.js-bym-nav-toggle-close');
                    if (navClose) {
                        const nav = document.querySelector('.js-bym-nav');
                        const navWrap = document.querySelector('.bym--nav');
                        if (nav) {
                            nav.classList.remove('is-active');
                            if (navWrap) navWrap.classList.remove('is-open');
                        }
                        return;
                    }
                    // BYM Nav Item Button (category tab switch)
                    const navItemBtn = e.target.closest('.bym--nav__item-btn');
                    if (navItemBtn) {
                        const btnId = navItemBtn.id;
                        if (!btnId) return;
                        const tabId = `tab-${btnId}`;
                        // Remove active from all tabs
                        document.querySelectorAll('.bym--products__tab.active').forEach(tab => tab.classList.remove('active'));
                        // Remove active from all nav items
                        document.querySelectorAll('.bym--nav__item.link.active').forEach(item => item.classList.remove('active'));
                        // Add active to the clicked nav item
                        const navItem = navItemBtn.closest('.bym--nav__item.link');
                        if (navItem) navItem.classList.add('active');
                        // Add active to the corresponding tab
                        const tab = document.getElementById(tabId);
                        if (tab) tab.classList.add('active');
                        // Scroll to top of BYM section
                        const bymSection = document.querySelector('.bym');
                        if (bymSection) {
                            bymSection.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                        // Remove is-active from nav
                        const nav = document.querySelector('.js-bym-nav');
                        if (nav) nav.classList.remove('is-active');
                        return;
                    }
                    // BYM Cart Toggle
                    const cartToggle = e.target.closest('.js-bym-cart-toggle');
                    if (cartToggle) {
                        const cartWrap = document.querySelector('.js-bym-cart-wrap');
                        if (cartWrap) {
                            cartWrap.classList.toggle('is-expanded');
                        }
                        return;
                    }
                });

                // SCROLL TO TOP, THIS WORKS
                document.body.addEventListener('click', function (e) {
                    const scrollTopBtn = e.target.closest('.bym--nav__scroll-top-btn');
                    if (!scrollTopBtn) return;

                    // Smooth scroll to top
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });

                // PRODUCT DESCRIPTION TOGGLE IN MOBILE, THIS WORKS
                document.addEventListener('click', function (e) {
                    const button = e.target.closest('.bym-product__tab-description-toggle');
                    if (!button) return;

                    const wrapper = button.closest('.bym-product__tab-description-wrap');
                    if (!wrapper) return;

                    const desc = wrapper.querySelector('.bym-product__tab-description');
                    if (!desc) return;

                    // Toggle description visibility
                    desc.classList.toggle('open');

                    // Toggle button icon state
                    button.classList.toggle('open');
                });

                // --- BYM Product Variant Change Handler ---
                document.body.addEventListener('change', function (e) {
                    const select = e.target.closest('.js-product-variant-select');
                    if (!select) return;
                    const form = select.closest('.bym-product__form-wrap, .bym-product__tab-form-mobile, .bym-product__tab-form-desktop');
                    if (!form) return;
                    // Find the product context
                    const bymProduct = (0, _getClosest.default)(form, '.bym-product');
                    if (!bymProduct) return;
                    // Get product JSON from a data attribute or window object
                    let productData = bymProduct.__productData;
                    if (!productData) {
                        const jsonScript = bymProduct.querySelector('script[type="application/json"][data-product]');
                        if (jsonScript) {
                            try {
                                productData = JSON.parse(jsonScript.textContent);
                            } catch (e) { }
                        }
                    }
                    if (!productData) return;
                    // Find selected variant from THIS form
                    const selectEl = form.querySelector('.js-product-variant-select');
                    let variantId = null;
                    if (selectEl && selectEl.value) {
                        variantId = selectEl.value;
                        productData._selected_variant_id = variantId;
                        form._selected_variant_id = variantId;
                    } else if (productData.selected_or_first_available_variant) {
                        variantId = productData.selected_or_first_available_variant.id;
                        productData._selected_variant_id = variantId;
                        form._selected_variant_id = variantId;
                    } else if (productData.variants && productData.variants.length === 1) {
                        variantId = productData.variants[0].id;
                        productData._selected_variant_id = variantId;
                        form._selected_variant_id = variantId;
                    }
                    if (!variantId) {
                        console.error('No variantId found for product', productData);
                        return;
                    }
                    const variant = productData.variants.find(v => String(v.id) === String(variantId));
                    if (!variant) {
                        console.error('No variant found for id', variantId, productData.variants);
                        return;
                    }
                    // Helper to format price without trailing zeros
                    function formatMoneyNoZeros(amount) {
                        var value = amount / 100;
                        return '$' + (value % 1 === 0 ? value.toFixed(0) : value.toFixed(2));
                    }
                    // Update price and compare at price in the add button for THIS form only
                    const priceWraps = form.querySelectorAll('.js-product-total-price');
                    priceWraps.forEach(priceWrap => {
                        if (variant.compare_at_price > variant.price) {
                            priceWrap.innerHTML = '<span class="dash">-</span> <span class="js-product-compare-price" style="text-decoration:line-through; font-size:12px; font-weight: 400;">' + formatMoneyNoZeros(variant.compare_at_price) + '</span> ' + formatMoneyNoZeros(variant.price);
                        } else {
                            priceWrap.innerHTML = '<span class="dash">-</span> ' + formatMoneyNoZeros(variant.price);
                        }
                    });
                    // Update button state for THIS form only
                    const btn = form.querySelector('.js-product-form-submit');
                    const availableText = form.querySelector('.js-product-form-submit-text-available');
                    const soldoutText = form.querySelector('.js-product-form-submit-text-soldout');
                    if (btn) {
                        if (variant.available) {
                            btn.disabled = false;
                            if (availableText) availableText.classList.remove('hidden');
                            if (soldoutText) soldoutText.classList.add('hidden');
                        } else {
                            btn.disabled = true;
                            if (availableText) availableText.classList.add('hidden');
                            if (soldoutText) soldoutText.classList.remove('hidden');
                        }
                    }
                });

                // --- BYM Add to Bundle Handler ---
                document.body.addEventListener('click', function (e) {
                    const addBtn = e.target.closest('.bym-form__submit');
                    if (addBtn && addBtn.name === 'add') {
                        e.preventDefault();
                        // Find the form context
                        const form = addBtn.closest('.bym-product__form-wrap, .bym-product__tab-form-mobile, .bym-product__tab-form-desktop');
                        if (!form) return;
                        const bymProduct = (0, _getClosest.default)(form, '.bym-product');
                        if (!bymProduct) {
                            console.log('No .bym-product found');
                            return;
                        }
                        // Close Learn More modal if open
                        const tab = bymProduct.querySelector('.bym-product__tab');
                        if (tab && tab.style.display !== 'none') {
                            tab.style.display = 'none';
                        }
                        // Get product data
                        let productData = bymProduct.__productData;
                        if (!productData) {
                            const jsonScript = bymProduct.querySelector('script[type="application/json"][data-product]');
                            if (jsonScript) {
                                try {
                                    productData = JSON.parse(jsonScript.textContent);
                                } catch (e) {
                                    console.log('Error parsing product JSON', e);
                                }
                            }
                        }
                        if (!productData) {
                            console.log('No productData found');
                            return;
                        }
                        // Get selected variant from THIS form
                        let variantId = form._selected_variant_id;
                        if (!variantId) {
                            const select = form.querySelector('.js-product-variant-select');
                            if (select && select.value) {
                                variantId = select.value;
                            }
                        }
                        // If no selector, get from button data-variant-id
                        if (!variantId && addBtn.hasAttribute('data-variant-id')) {
                            variantId = addBtn.getAttribute('data-variant-id');
                        }
                        if (!variantId) {
                            variantId = productData.selected_or_first_available_variant ? productData.selected_or_first_available_variant.id : null;
                        }
                        productData._selected_variant_id = variantId;
                        if (!variantId) return;
                        const variant = productData.variants.find(v => String(v.id) === String(variantId));
                        if (!variant) {
                            console.log('No variant found for id', variantId);
                            return;
                        }
                        const variantTitle = variant.title;
                        const title = productData.title;
                        const price = formatMoney(variant.price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}');
                        // Build product image tag after title is defined
                        let imgSrc = '';
                        if (variant.featured_image && variant.featured_image.src) {
                            imgSrc = variant.featured_image.src;
                        } else if (productData.featured_image) {
                            imgSrc = typeof productData.featured_image === 'string' ? productData.featured_image : productData.featured_image.src;
                        }
                        const imgTag = imgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${imgSrc}\" alt=\"${title}\">` : '';
                        // Find first empty tier
                        const cartTiers = document.querySelectorAll('.bym--cart__tier-product');
                        let targetTier = null;
                        for (let tier of cartTiers) {
                            if (!tier.hasChildNodes() || tier.innerHTML.trim() === '') {
                                targetTier = tier;
                                break;
                            }
                        }
                        if (!targetTier) {
                            console.log('No empty tier found');
                            return;
                        }
                        // Get discount info from the tier being filled
                        const targetTierElem = targetTier.closest('.bym--cart__tier');
                        const {
                            discount: newDiscount,
                            dollarDiscount: newDollarDiscount
                        } = getTierDiscountInfo(targetTierElem);
                        // Only show variant if not 'Default Title'
                        let variantHtml = '';
                        if (variantTitle && variantTitle.toLowerCase() !== 'default title') {
                            variantHtml = `<div class=\"bym--cart__tier-product-variant\">${variantTitle}</div>`;
                        }
                        // Check for discount percentage or dollar in tier
                        let tierDiscount = 0;
                        let dollarDiscount = 0;
                        if (targetTier) {
                            const tierElem = targetTier.closest('.bym--cart__tier');
                            const discountEl = tierElem.querySelector('.bym--cart__discount-percentage-off');
                            const dollarEl = tierElem.querySelector('.bym--cart__discount-dollar-off');
                            if (discountEl && discountEl.textContent.trim() !== '') {
                                tierDiscount = parseFloat(discountEl.textContent.trim()) || 0;
                            } else if (dollarEl && dollarEl.textContent.trim() !== '') {
                                dollarDiscount = parseFloat(dollarEl.textContent.replace(/[^\d.]/g, '')) || 0;
                            }
                        }
                        // Calculate compare price if discount > 0
                        let comparePriceHtml = '';
                        let showLineThrough = false;
                        if (tierDiscount > 0) {
                            const discounted = variant.price * (1 - tierDiscount / 100);
                            comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                            showLineThrough = true;
                        } else if (dollarDiscount > 0) {
                            const discounted = variant.price - dollarDiscount * 100;
                            comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                            showLineThrough = true;
                        }
                        // Main product HTML
                        let mainProductHtml = `
        <div class=\"bym--cart__tier-product-item\" style=\"display:flex;align-items:center;gap:15px;height: 100%;padding:10px\">
          ${imgTag}
          <div class=\"bym--cart__tier-product-info\">
            <div class=\"bym--cart__tier-product-title\">${title}</div>
            ${variantHtml}
            <div class=\"bym--cart__tier-product-price-wrap\">
              <div class=\"bym--cart__tier-product-compare-price${showLineThrough ? '' : ' no-line-through'}\">${price}</div>
              ${comparePriceHtml}
            </div>
          </div>
          <button class=\"bym--cart__tier-product-remove\" aria-label=\"Remove\">
            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10.707\" height=\"10.707\" viewBox=\"0 0 10.707 10.707\"><g data-name=\"Component 14 – 4\" transform=\"translate(0.354 0.354)\"><line data-name=\"Line 81\" y2=\"14.142\" transform=\"translate(10) rotate(45)\" fill=\"none\" stroke-width=\"1\"/><line data-name=\"Line 82\" y2=\"14.142\" transform=\"translate(0 0) rotate(-45)\" fill=\"none\" stroke-width=\"1\"/></g></svg>
          </button>
        </div>
      `;
                        // Bonus product HTML (if any)
                        const bonusProductEl = targetTierElem.querySelector('.bym--cart__tier-bonus-product');
                        if (bonusProductEl && bonusProductEl.textContent.trim() !== '') {
                            const bonusProductId = bonusProductEl.textContent.trim();
                            const bonusLineItemEl = targetTierElem.querySelector('.bym--cart__tier-bonus-product-line-item');
                            let bonusLineItemProp = '';
                            if (bonusLineItemEl && bonusLineItemEl.textContent.trim() !== '') {
                                bonusLineItemProp = bonusLineItemEl.textContent.trim();
                            }
                            fetch(`/products/${bonusProductId}.js`).then(res => res.json()).then(bonusProductData => {
                                const bonusVariant = bonusProductData.variants[0];
                                const bonusTitle = bonusProductData.title;
                                const bonusImgSrc = bonusVariant.featured_image ? bonusVariant.featured_image.src : bonusProductData.featured_image ? typeof bonusProductData.featured_image === 'string' ? bonusProductData.featured_image : bonusProductData.featured_image.src : '';
                                const bonusImgTag = bonusImgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${bonusImgSrc}\" alt=\"${bonusTitle}\">` : '';
                                // Add price and compare-at price for bonus item (100% discount)
                                const bonusPrice = formatMoney(0, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}');
                                let bonusComparePriceHtml = '';
                                if (bonusVariant.compare_at_price && bonusVariant.compare_at_price > bonusVariant.price) {
                                    bonusComparePriceHtml = `<div class=\"bym--cart__tier-product-compare-price\">${formatMoney(bonusVariant.compare_at_price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                } else {
                                    bonusComparePriceHtml = `<div class=\"bym--cart__tier-product-compare-price\">${formatMoney(bonusVariant.price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                }
                                let bonusProductHtml = `
            <div class=\"bym--cart__tier-product-item bym--cart__tier-bonus\" style=\"position:relative;display:flex;align-items:center;gap:15px;height: 80px;padding:10px;background:#FFEBDD;border:1px solid #ff6c00;margin-top:10px;\" data-bonus-product-id=\"${bonusVariant.id}\" data-bonus-line-item-prop=\"${bonusLineItemProp}\">\n              ${bonusImgTag}\n              <div class=\"bym--cart__tier-product-info\">\n                <div class=\"bym--cart__tier-product-free\">Free Gift</div>\n                <div class=\"bym--cart__tier-product-title\">${bonusTitle}</div>\n                <div class=\"bym--cart__tier-product-price-wrap\">\n                  ${bonusComparePriceHtml}\n                  <div class=\"bym--cart__tier-product-price\">${bonusPrice}</div>\n                </div>\n              </div>\n              <div class=\"bym--cart__tier-connect\"></div>\n            </div>\n          `;
                                targetTier.innerHTML = `<div class=\"bym--cart__tier-products-stack\">${mainProductHtml}${bonusProductHtml}</div>`;
                                targetTierElem.classList.add('double-height');
                                // Attach productData for main and bonus product
                                targetTier.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)').__productData = productData;
                                targetTier.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus').__productData = bonusProductData;
                                // Update Add to Cart button state after both products are rendered
                                updateBYMAddToCartButtonState();
                            });
                        } else {
                            targetTier.innerHTML = mainProductHtml;
                            targetTierElem.classList.remove('double-height');
                            targetTier.querySelector('.bym--cart__tier-product-item').__productData = productData;
                            updateBYMAddToCartButtonState();
                        }
                        // Attach productData for later use
                        if (productData) targetTier.__productData = productData;
                        // Hide empty text and add active class
                        const filledTierElem = targetTier.closest('.bym--cart__tier');
                        if (filledTierElem) filledTierElem.classList.add('active');
                        const emptyTextWrap = filledTierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                        if (emptyTextWrap) emptyTextWrap.style.display = 'none';
                        // Now apply the discount from this tier to ALL filled tiers (including the newly added one)
                        document.querySelectorAll('.bym--cart__tier-product').forEach(tierProduct => {
                            if (tierProduct.innerHTML.trim() !== '') {
                                const productData = tierProduct.__productData;
                                let variant = null;
                                let variantId = null;
                                if (productData && productData._selected_variant_id) {
                                    variantId = productData._selected_variant_id;
                                    variant = productData.variants.find(v => String(v.id) === String(variantId));
                                }
                                if (!variant && productData && productData.selected_or_first_available_variant) {
                                    variant = productData.selected_or_first_available_variant;
                                    variantId = variant.id;
                                }
                                if (!variant && productData && productData.variants && productData.variants.length) {
                                    variant = productData.variants[0];
                                    variantId = variant.id;
                                }
                                if (!variantId) {
                                    console.error('No variantId found for product', productData);
                                    return;
                                }
                                let price = variant ? variant.price : 0;
                                let variantHtml = '';
                                if (variant && variant.title && variant.title.toLowerCase() !== 'default title') {
                                    variantHtml = `<div class=\"bym--cart__tier-product-variant\">${variant.title}</div>`;
                                }
                                let imgSrc = '';
                                if (variant && variant.featured_image && variant.featured_image.src) {
                                    imgSrc = variant.featured_image.src;
                                } else if (productData && productData.featured_image) {
                                    imgSrc = typeof productData.featured_image === 'string' ? productData.featured_image : productData.featured_image.src;
                                }
                                const imgTag = imgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${imgSrc}\" alt=\"${productData ? productData.title : ''}\">` : '';
                                let comparePriceHtml = '';
                                let showLineThrough = false;
                                if (newDiscount > 0) {
                                    const discounted = price * (1 - newDiscount / 100);
                                    comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                    showLineThrough = true;
                                } else if (newDollarDiscount > 0) {
                                    const discounted = price - newDollarDiscount * 100;
                                    comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                    showLineThrough = true;
                                }
                                let mainProductHtml = `
            <div class=\"bym--cart__tier-product-item\" style=\"display:flex;align-items:center;gap:15px;height: 100%;padding:10px;\">${imgTag}<div class=\"bym--cart__tier-product-info\"><div class=\"bym--cart__tier-product-title\">${productData ? productData.title : ''}\</div>${variantHtml}<div class=\"bym--cart__tier-product-price-wrap\"><div class=\"bym--cart__tier-product-compare-price${showLineThrough ? '' : ' no-line-through'}\">${formatMoney(price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>${comparePriceHtml}</div></div><button class=\"bym--cart__tier-product-remove\" aria-label=\"Remove\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10.707\" height=\"10.707\" viewBox=\"0 0 10.707 10.707\"><g data-name=\"Component 14 – 4\" transform=\"translate(0.354 0.354)\"><line data-name=\"Line 81\" y2=\"14.142\" transform=\"translate(10) rotate(45)\" fill=\"none\" stroke-width=\"1\"/><line data-name=\"Line 82\" y2=\"14.142\" transform=\"translate(0 0) rotate(-45)\" fill=\"none\" stroke-width=\"1\"/></g></svg></button></div>`;
                                // If there's a bonus product, keep it as is
                                const bonusItem = tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus');
                                if (bonusItem) {
                                    tierProduct.innerHTML = `<div class=\"bym--cart__tier-products-stack\">${mainProductHtml}${bonusItem.outerHTML}</div>`;
                                    tierProduct.closest('.bym--cart__tier').classList.add('double-height');
                                    tierProduct.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)').__productData = productData;
                                    tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus').__productData = bonusItem.__productData;
                                } else {
                                    tierProduct.innerHTML = mainProductHtml;
                                    tierProduct.closest('.bym--cart__tier').classList.remove('double-height');
                                    tierProduct.querySelector('.bym--cart__tier-product-item').__productData = productData;
                                }
                                if (productData) tierProduct.__productData = productData;
                                const filledTierElem = tierProduct.closest('.bym--cart__tier');
                                if (filledTierElem) filledTierElem.classList.add('active');
                                const emptyTextWrap = filledTierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                                if (emptyTextWrap) emptyTextWrap.style.display = 'none';
                            }
                        });
                        updateBYMAddToCartButtonState();
                        // Open BYM cart on mobile if not already expanded
                        const cartWrap = document.querySelector('.js-bym-cart-wrap');
                        if (cartWrap && !cartWrap.classList.contains('is-expanded')) {
                            cartWrap.classList.add('is-expanded');
                        }
                    }
                });

                // --- BYM Remove from Tier Handler ---
                document.body.addEventListener('click', function (e) {
                    const removeBtn = e.target.closest('.bym--cart__tier-product-remove');
                    if (removeBtn) {
                        // Find the tier product div
                        const tierProduct = removeBtn.closest('.bym--cart__tier-product');
                        if (!tierProduct) return;
                        // Find all tier product containers
                        const allTiers = Array.from(document.querySelectorAll('.bym--cart__tier-product'));
                        const thisIndex = allTiers.indexOf(tierProduct);
                        // Store productData for each tier before shifting
                        const tierProductDataArr = allTiers.map(tier => {
                            const mainItem = tier.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)');
                            return mainItem ? mainItem.__productData : null;
                        });
                        // Shift up products below
                        for (let i = thisIndex; i < allTiers.length - 1; i++) {
                            // Only shift main product, not bonus product
                            const nextTierItems = allTiers[i + 1].querySelectorAll('.bym--cart__tier-product-item');
                            let nextMainProduct = null;
                            nextTierItems.forEach(item => {
                                if (!item.classList.contains('bym--cart__tier-bonus')) {
                                    nextMainProduct = item;
                                }
                            });
                            // Remove any bonus product from current tier
                            allTiers[i].querySelectorAll('.bym--cart__tier-product-item.bym--cart__tier-bonus').forEach(bonus => bonus.remove());
                            // Move main product up
                            if (nextMainProduct) {
                                allTiers[i].innerHTML = '';
                                const cloned = nextMainProduct.cloneNode(true);
                                allTiers[i].appendChild(cloned);
                                // Set __productData from stored array
                                const pd = tierProductDataArr[i + 1];
                                if (pd) {
                                    allTiers[i].__productData = pd;
                                    allTiers[i].firstElementChild.__productData = pd;
                                }
                            } else {
                                allTiers[i].innerHTML = '';
                                allTiers[i].__productData = null;
                            }
                        }
                        // Clear last tier
                        allTiers[allTiers.length - 1].innerHTML = '';
                        // Show empty text if needed
                        for (let i = thisIndex; i < allTiers.length; i++) {
                            if (!allTiers[i].hasChildNodes() || allTiers[i].innerHTML.trim() === '') {
                                const emptyTextWrap = allTiers[i].closest('.bym--cart__tier').querySelector('.bym--cart__tier-empty-text-wrap');
                                if (emptyTextWrap) emptyTextWrap.style.display = '';
                                // Remove active class from tier
                                const tierElem = allTiers[i].closest('.bym--cart__tier');
                                if (tierElem) tierElem.classList.remove('active');
                            }
                        }
                        // Find the new highest filled tier and apply its discount to all filled tiers
                        const tiers = document.querySelectorAll('.bym--cart__tier');
                        let lastFilledTier = null;
                        tiers.forEach(tierElem => {
                            const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                            if (tierProduct && tierProduct.innerHTML.trim() !== '') {
                                lastFilledTier = tierElem;
                            }
                        });
                        let newDiscount = 0;
                        let newDollarDiscount = 0;
                        if (lastFilledTier) {
                            const info = getTierDiscountInfo(lastFilledTier);
                            newDiscount = info.discount;
                            newDollarDiscount = info.dollarDiscount;
                        }
                        // Rebuild HTML for all filled tiers with new discount
                        document.querySelectorAll('.bym--cart__tier-product').forEach((tierProduct, idx) => {
                            if (tierProduct.innerHTML.trim() !== '') {
                                const productData = tierProduct.__productData;
                                let variant = null;
                                let variantId = null;
                                if (productData && productData._selected_variant_id) {
                                    variantId = productData._selected_variant_id;
                                    variant = productData.variants.find(v => String(v.id) === String(variantId));
                                }
                                if (!variant && productData && productData.selected_or_first_available_variant) {
                                    variant = productData.selected_or_first_available_variant;
                                    variantId = variant.id;
                                }
                                if (!variant && productData && productData.variants && productData.variants.length) {
                                    variant = productData.variants[0];
                                    variantId = variant.id;
                                }
                                if (!variantId) {
                                    console.error('No variantId found for product', productData);
                                    return;
                                }
                                let price = variant ? variant.price : 0;
                                let variantHtml = '';
                                if (variant && variant.title && variant.title.toLowerCase() !== 'default title') {
                                    variantHtml = `<div class=\"bym--cart__tier-product-variant\">${variant.title}</div>`;
                                }
                                let imgSrc = '';
                                if (variant && variant.featured_image && variant.featured_image.src) {
                                    imgSrc = variant.featured_image.src;
                                } else if (productData && productData.featured_image) {
                                    imgSrc = typeof productData.featured_image === 'string' ? productData.featured_image : productData.featured_image.src;
                                }
                                const imgTag = imgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${imgSrc}\" alt=\"${productData ? productData.title : ''}\">` : '';
                                let comparePriceHtml = '';
                                let showLineThrough = false;
                                if (newDiscount > 0) {
                                    const discounted = price * (1 - newDiscount / 100);
                                    comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                    showLineThrough = true;
                                } else if (newDollarDiscount > 0) {
                                    const discounted = price - newDollarDiscount * 100;
                                    comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                    showLineThrough = true;
                                }
                                let mainProductHtml = `
            <div class=\"bym--cart__tier-product-item\" style=\"display:flex;align-items:center;gap:15px;height: 100%;padding:10px;\">${imgTag}<div class=\"bym--cart__tier-product-info\"><div class=\"bym--cart__tier-product-title\">${productData ? productData.title : ''}\</div>${variantHtml}<div class=\"bym--cart__tier-product-price-wrap\"><div class=\"bym--cart__tier-product-compare-price${showLineThrough ? '' : ' no-line-through'}\">${formatMoney(price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>${comparePriceHtml}</div></div><button class=\"bym--cart__tier-product-remove\" aria-label=\"Remove\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10.707\" height=\"10.707\" viewBox=\"0 0 10.707 10.707\"><g data-name=\"Component 14 – 4\" transform=\"translate(0.354 0.354)\"><line data-name=\"Line 81\" y2=\"14.142\" transform=\"translate(10) rotate(45)\" fill=\"none\" stroke-width=\"1\"/><line data-name=\"Line 82\" y2=\"14.142\" transform=\"translate(0 0) rotate(-45)\" fill=\"none\" stroke-width=\"1\"/></g></svg></button></div>`;
                                // If there's a bonus product, keep it as is
                                const bonusItem = tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus');
                                if (bonusItem) {
                                    tierProduct.innerHTML = `<div class=\"bym--cart__tier-products-stack\">${mainProductHtml}${bonusItem.outerHTML}</div>`;
                                    tierProduct.closest('.bym--cart__tier').classList.add('double-height');
                                    tierProduct.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)').__productData = productData;
                                    tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus').__productData = bonusItem.__productData;
                                } else {
                                    tierProduct.innerHTML = mainProductHtml;
                                    tierProduct.closest('.bym--cart__tier').classList.remove('double-height');
                                    tierProduct.querySelector('.bym--cart__tier-product-item').__productData = productData;
                                }
                                if (productData) tierProduct.__productData = productData;
                                const filledTierElem = tierProduct.closest('.bym--cart__tier');
                                if (filledTierElem) filledTierElem.classList.add('active');
                                const emptyTextWrap = filledTierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                                if (emptyTextWrap) emptyTextWrap.style.display = 'none';
                            }
                        });
                        // Remove double-height from tiers that no longer have a bonus product
                        document.querySelectorAll('.bym--cart__tier').forEach(tierElem => {
                            const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                            if (tierProduct && !tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus')) {
                                tierElem.classList.remove('double-height');
                            }
                        });
                        updateBYMAddToCartButtonState();
                    }
                });
                function updateMotivatorMessage() {
                    var tiers = document.querySelectorAll('.bym--cart__tier');
                    var motivateMessage = document.querySelector('.bym--cart__motivate-message');

                    if (!motivateMessage) return;

                    // Cache the initial HTML once
                    if (!motivateMessage.dataset.defaultHtml) {
                        motivateMessage.dataset.defaultHtml = motivateMessage.innerHTML;
                    }

                    var lastFilledTier = null;

                    tiers.forEach(function (tierElem) {
                        var tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                        if (tierProduct && tierProduct.innerHTML.trim() !== '') {
                            lastFilledTier = tierElem;
                        }
                    });

                    if (lastFilledTier) {
                        var motivatorDiv = lastFilledTier.querySelector(
                            '.bym--cart__tier-motivator-message'
                        );
                        motivateMessage.innerHTML = motivatorDiv
                            ? motivatorDiv.innerHTML
                            : '';
                    } else {
                        // Restore hardcoded HTML when bundle is empty
                        motivateMessage.innerHTML = motivateMessage.dataset.defaultHtml;
                    }
                }
let cartExpanded = false; // outside the function

function updateBYMAddToCartButtonState() {
  console.log('updateBYMAddToCartButtonState called', new Date().toISOString());

  updateMotivatorMessage();

  const cartWrap = document.querySelector('.bym--cart.js-bym-cart-wrap');
  const bymSection = document.querySelector('.bym');
  const tiers = document.querySelectorAll('.bym--cart__tier');

  if (!cartWrap || !bymSection) return;

  // Count tiers that contain a product
  const filledCount = Array.from(tiers).filter(tier =>
    tier.querySelector('.bym--cart__tier-product-item')
  ).length;

  console.log('Filled tiers:', filledCount, 'Total tiers:', tiers.length);

  /* -----------------------------
  CART EXPANSION LOGIC
  ----------------------------- */

  if (filledCount === tiers.length) {
    bymSection.classList.add('bym--full');

    if (!cartExpanded) {
      console.log('Expanding cart — last tier added');
      cartWrap.classList.add('is-expanded');
      cartExpanded = true;
    }
  } else {
    bymSection.classList.remove('bym--full');

    if (cartWrap.classList.contains('is-expanded')) {
      console.log('Collapsing cart — not all tiers filled');
      cartWrap.classList.remove('is-expanded');
      cartExpanded = false;
    }
  }

  /* -----------------------------
  ADD TO CART BUTTON
  ----------------------------- */

  const addToCartBtn = document.querySelector('.bym--cart__add-to-cart');

  if (addToCartBtn) {

    // Enable button only after 2 items
    addToCartBtn.disabled = filledCount < 2;

    // Only show bundle price after 2 items
    if (filledCount >= 2) {

      const priceEls = document.querySelectorAll('.bym--cart__tier-product-price');
      let total = 0;

      priceEls.forEach(el => {
        const priceText = el.textContent.replace(/[^\d.]/g, '');
        const price = parseFloat(priceText);
        if (!isNaN(price)) total += price;
      });

      addToCartBtn.innerHTML = `Add to Cart - $${total.toFixed(2)}`;

    } else {

      addToCartBtn.innerHTML = `Add to Cart`;

    }
  }
}
                const favoritesBtn = document.querySelector('.bym-hero__favorites-btn');
                if (favoritesBtn && window.BYM_FAVORITE_PRODUCT_HANDLES && window.BYM_FAVORITE_PRODUCT_HANDLES.length) {
                    favoritesBtn.addEventListener('click', function () {
                        const cartTiers = document.querySelectorAll('.bym--cart__tier-product');
                        let tierIndex = 0;
                        // Expand BYM cart when favorites are added
                        const cartWrap = document.querySelector('.js-bym-cart-wrap');
                        if (cartWrap) cartWrap.classList.add('is-expanded');
                        function addFavoriteToTier(handle, next) {
                            fetch(`/products/${handle}.js`).then(res => res.json()).then(productData => {
                                const variant = productData.variants.find(v => v.available) || productData.variants[0];
                                if (!variant) return next();
                                // Find next empty tier
                                let targetTier = null;
                                for (; tierIndex < cartTiers.length; tierIndex++) {
                                    if (!cartTiers[tierIndex].hasChildNodes() || cartTiers[tierIndex].innerHTML.trim() === '') {
                                        targetTier = cartTiers[tierIndex];
                                        break;
                                    }
                                }
                                if (!targetTier) return next();
                                const targetTierElem = targetTier.closest('.bym--cart__tier');
                                // Only show variant if not 'Default Title'
                                let variantHtml = '';
                                if (variant.title && variant.title.toLowerCase() !== 'default title') {
                                    variantHtml = `<div class=\"bym--cart__tier-product-variant\">${variant.title}</div>`;
                                }
                                // Build product image tag after title is defined
                                let imgSrc = '';
                                if (variant.featured_image && variant.featured_image.src) {
                                    imgSrc = variant.featured_image.src;
                                } else if (productData.featured_image) {
                                    imgSrc = typeof productData.featured_image === 'string' ? productData.featured_image : productData.featured_image.src;
                                }
                                const imgTag = imgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${imgSrc}\" alt=\"${productData.title}\">` : '';
                                // Get discount info from the tier being filled
                                const {
                                    discount: newDiscount,
                                    dollarDiscount: newDollarDiscount
                                } = getTierDiscountInfo(targetTierElem);
                                // Check for discount percentage or dollar in tier
                                let tierDiscount = 0;
                                let dollarDiscount = 0;
                                if (targetTier) {
                                    const tierElem = targetTier.closest('.bym--cart__tier');
                                    const discountEl = tierElem.querySelector('.bym--cart__discount-percentage-off');
                                    const dollarEl = tierElem.querySelector('.bym--cart__discount-dollar-off');
                                    if (discountEl && discountEl.textContent.trim() !== '') {
                                        tierDiscount = parseFloat(discountEl.textContent.trim()) || 0;
                                    } else if (dollarEl && dollarEl.textContent.trim() !== '') {
                                        dollarDiscount = parseFloat(dollarEl.textContent.replace(/[^\d.]/g, '')) || 0;
                                    }
                                }
                                // Calculate compare price if discount > 0
                                let comparePriceHtml = '';
                                let showLineThrough = false;
                                if (tierDiscount > 0) {
                                    const discounted = variant.price * (1 - tierDiscount / 100);
                                    comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                    showLineThrough = true;
                                } else if (dollarDiscount > 0) {
                                    const discounted = variant.price - dollarDiscount * 100;
                                    comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                    showLineThrough = true;
                                }
                                let mainProductHtml = `
          <div class=\"bym--cart__tier-product-item\" style=\"display:flex;align-items:center;gap:15px;height: 100%;padding:10px\">${imgTag}<div class=\"bym--cart__tier-product-info\"><div class=\"bym--cart__tier-product-title\">${productData.title}</div>${variantHtml}<div class=\"bym--cart__tier-product-price-wrap\"><div class=\"bym--cart__tier-product-compare-price${showLineThrough ? '' : ' no-line-through'}\">${formatMoney(variant.price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>${comparePriceHtml}</div></div><button class=\"bym--cart__tier-product-remove\" aria-label=\"Remove\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10.707\" height=\"10.707\" viewBox=\"0 0 10.707 10.707\"><g data-name=\"Component 14 – 4\" transform=\"translate(0.354 0.354)\"><line data-name=\"Line 81\" y2=\"14.142\" transform=\"translate(10) rotate(45)\" fill=\"none\" stroke-width=\"1\"/><line data-name=\"Line 82\" y2=\"14.142\" transform=\"translate(0 0) rotate(-45)\" fill=\"none\" stroke-width=\"1\"/></g></svg></button></div>`;
                                // Bonus product logic
                                const bonusProductEl = targetTierElem.querySelector('.bym--cart__tier-bonus-product');
                                if (bonusProductEl && bonusProductEl.textContent.trim() !== '') {
                                    const bonusProductId = bonusProductEl.textContent.trim();
                                    const bonusLineItemEl = targetTierElem.querySelector('.bym--cart__tier-bonus-product-line-item');
                                    let bonusLineItemProp = '';
                                    if (bonusLineItemEl && bonusLineItemEl.textContent.trim() !== '') {
                                        bonusLineItemProp = bonusLineItemEl.textContent.trim();
                                    }
                                    fetch(`/products/${bonusProductId}.js`).then(res => res.json()).then(bonusProductData => {
                                        const bonusVariant = bonusProductData.variants[0];
                                        const bonusTitle = bonusProductData.title;
                                        const bonusImgSrc = bonusVariant.featured_image ? bonusVariant.featured_image.src : bonusProductData.featured_image ? typeof bonusProductData.featured_image === 'string' ? bonusProductData.featured_image : bonusProductData.featured_image.src : '';
                                        const bonusImgTag = bonusImgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${bonusImgSrc}\" alt=\"${bonusTitle}\">` : '';
                                        const bonusPrice = formatMoney(0, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}');
                                        let bonusComparePriceHtml = '';
                                        if (bonusVariant.compare_at_price && bonusVariant.compare_at_price > bonusVariant.price) {
                                            bonusComparePriceHtml = `<div class=\"bym--cart__tier-product-compare-price\">${formatMoney(bonusVariant.compare_at_price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                        } else {
                                            bonusComparePriceHtml = `<div class=\"bym--cart__tier-product-compare-price\">${formatMoney(bonusVariant.price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                        }
                                        let bonusProductHtml = `
              <div class=\"bym--cart__tier-product-item bym--cart__tier-bonus\" style=\"position:relative;display:flex;align-items:center;gap:15px;height: 80px;padding:10px;background:#FFEBDD;border:1px solid #ff6c00;margin-top:10px;\" data-bonus-product-id=\"${bonusVariant.id}\" data-bonus-line-item-prop=\"${bonusLineItemProp}\">${bonusImgTag}<div class=\"bym--cart__tier-product-info\"><div class=\"bym--cart__tier-product-free\">Free Gift</div><div class=\"bym--cart__tier-product-title\">${bonusTitle}</div><div class=\"bym--cart__tier-product-price-wrap\">${bonusComparePriceHtml}<div class=\"bym--cart__tier-product-price\">${bonusPrice}</div></div></div><div class=\"bym--cart__tier-connect\"></div></div>`;
                                        targetTier.innerHTML = `<div class=\"bym--cart__tier-products-stack\">${mainProductHtml}${bonusProductHtml}</div>`;
                                        targetTierElem.classList.add('double-height');
                                        targetTier.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)').__productData = productData;
                                        targetTier.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus').__productData = bonusProductData;
                                        if (productData) targetTier.__productData = productData;
                                        const filledTierElem = targetTier.closest('.bym--cart__tier');
                                        if (filledTierElem) filledTierElem.classList.add('active');
                                        const emptyTextWrap = filledTierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                                        if (emptyTextWrap) emptyTextWrap.style.display = 'none';
                                        updateBYMAddToCartButtonState();
                                        next();
                                    });
                                } else {
                                    targetTier.innerHTML = mainProductHtml;
                                    targetTierElem.classList.remove('double-height');
                                    targetTier.querySelector('.bym--cart__tier-product-item').__productData = productData;
                                    if (productData) targetTier.__productData = productData;
                                    const filledTierElem = targetTier.closest('.bym--cart__tier');
                                    if (filledTierElem) filledTierElem.classList.add('active');
                                    const emptyTextWrap = filledTierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                                    if (emptyTextWrap) emptyTextWrap.style.display = 'none';
                                    updateBYMAddToCartButtonState();
                                    next();
                                }
                            });
                        }
                        // Sequentially add each favorite product to a tier
                        function addFavoritesSequentially(index) {
                            if (index >= window.BYM_FAVORITE_PRODUCT_HANDLES.length || tierIndex >= cartTiers.length) {
                                applyLastTierDiscountToAllFilledTiers();
                                return;
                            }
                            addFavoriteToTier(window.BYM_FAVORITE_PRODUCT_HANDLES[index], function () {
                                addFavoritesSequentially(index + 1);
                            });
                        }
                        // Function to apply last tier discount to all filled tiers
                        function applyLastTierDiscountToAllFilledTiers() {
                            // Find last filled tier
                            const tiers = document.querySelectorAll('.bym--cart__tier');
                            let lastTierElem = null;
                            tiers.forEach(tierElem => {
                                const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                                if (tierProduct && tierProduct.innerHTML.trim() !== '') {
                                    lastTierElem = tierElem;
                                }
                            });
                            let newDiscount = 0;
                            let newDollarDiscount = 0;
                            if (lastTierElem) {
                                const info = getTierDiscountInfo(lastTierElem);
                                newDiscount = info.discount;
                                newDollarDiscount = info.dollarDiscount;
                            }
                            document.querySelectorAll('.bym--cart__tier-product').forEach(tierProduct => {
                                if (tierProduct.innerHTML.trim() !== '') {
                                    // Main product only
                                    const mainItem = tierProduct.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)');
                                    if (mainItem && mainItem.__productData) {
                                        const productData = mainItem.__productData;
                                        let price = 0;
                                        let variant = productData ? productData.selected_or_first_available_variant : null;
                                        if (!variant && productData && productData.variants && productData.variants.length) {
                                            variant = productData.variants[0];
                                        }
                                        if (variant) price = variant.price;
                                        let variantHtml = '';
                                        if (variant && variant.title && variant.title.toLowerCase() !== 'default title') {
                                            variantHtml = `<div class=\"bym--cart__tier-product-variant\">${variant.title}</div>`;
                                        }
                                        let imgSrc = '';
                                        if (variant && variant.featured_image && variant.featured_image.src) {
                                            imgSrc = variant.featured_image.src;
                                        } else if (productData && productData.featured_image) {
                                            imgSrc = typeof productData.featured_image === 'string' ? productData.featured_image : productData.featured_image.src;
                                        }
                                        const imgTag = imgSrc ? `<img class=\"bym--cart__tier-product-img\" src=\"${imgSrc}\" alt=\"${productData ? productData.title : ''}\">` : '';
                                        let comparePriceHtml = '';
                                        let showLineThrough = false;
                                        if (newDiscount > 0) {
                                            const discounted = price * (1 - newDiscount / 100);
                                            comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                            showLineThrough = true;
                                        } else if (newDollarDiscount > 0) {
                                            const discounted = price - newDollarDiscount * 100;
                                            comparePriceHtml = `<div class=\"bym--cart__tier-product-price\">${formatMoney(discounted, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>`;
                                            showLineThrough = true;
                                        }
                                        let mainProductHtml = `
              <div class=\"bym--cart__tier-product-item\" style=\"display:flex;align-items:center;gap:15px;height: 100%;padding:10px;\">${imgTag}<div class=\"bym--cart__tier-product-info\"><div class=\"bym--cart__tier-product-title\">${productData ? productData.title : ''}\</div>${variantHtml}<div class=\"bym--cart__tier-product-price-wrap\"><div class=\"bym--cart__tier-product-compare-price${showLineThrough ? '' : ' no-line-through'}\">${formatMoney(price, window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}')}</div>${comparePriceHtml}</div></div><button class=\"bym--cart__tier-product-remove\" aria-label=\"Remove\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10.707\" height=\"10.707\" viewBox=\"0 0 10.707 10.707\"><g data-name=\"Component 14 – 4\" transform=\"translate(0.354 0.354)\"><line data-name=\"Line 81\" y2=\"14.142\" transform=\"translate(10) rotate(45)\" fill=\"none\" stroke-width=\"1\"/><line data-name=\"Line 82\" y2=\"14.142\" transform=\"translate(0 0) rotate(-45)\" fill=\"none\" stroke-width=\"1\"/></g></svg></button></div>`;
                                        // If there's a bonus product, keep it as is
                                        const bonusItem = tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus');
                                        if (bonusItem) {
                                            tierProduct.innerHTML = `<div class=\"bym--cart__tier-products-stack\">${mainProductHtml}${bonusItem.outerHTML}</div>`;
                                            tierProduct.closest('.bym--cart__tier').classList.add('double-height');
                                            tierProduct.querySelector('.bym--cart__tier-product-item:not(.bym--cart__tier-bonus)').__productData = productData;
                                            tierProduct.querySelector('.bym--cart__tier-product-item.bym--cart__tier-bonus').__productData = bonusItem.__productData;
                                        } else {
                                            tierProduct.innerHTML = mainProductHtml;
                                            tierProduct.closest('.bym--cart__tier').classList.remove('double-height');
                                            tierProduct.querySelector('.bym--cart__tier-product-item').__productData = productData;
                                        }
                                        if (productData) tierProduct.__productData = productData;
                                        const filledTierElem = tierProduct.closest('.bym--cart__tier');
                                        if (filledTierElem) filledTierElem.classList.add('active');
                                        const emptyTextWrap = filledTierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                                        if (emptyTextWrap) emptyTextWrap.style.display = 'none';
                                    }
                                }
                            });
                            updateBYMAddToCartButtonState();
                        }
                        addFavoritesSequentially(0);
                    });
                }


                function resetBYMBundle() {
                    const tiers = document.querySelectorAll('.bym--cart__tier');
                    const tierProducts = document.querySelectorAll('.bym--cart__tier-product');
                    const bymSection = document.querySelector('.bym');
                    const addToCartBtn = document.querySelector('.bym--cart__add-to-cart');
                    const cartWrap = document.querySelector('.js-bym-cart-wrap');
                    const progressFill = document.querySelector('.bym--cart__progress-fill');
                    const progressNodes = document.querySelectorAll('.bym--cart__progress-node');
                    const progressLabels = document.querySelectorAll('.bym--cart__progress-label');

                    // Clear all tier products
                    tierProducts.forEach(container => {
                        container.innerHTML = '';
                        container.__productData = null;
                    });

                    // Reset tier classes + empty text
                    tiers.forEach(tier => {
                        tier.classList.remove('active', 'double-height');
                        const emptyTextWrap = tier.querySelector('.bym--cart__tier-empty-text-wrap');
                        if (emptyTextWrap) emptyTextWrap.style.display = '';
                    });

                    // Reset add to cart button
                    if (addToCartBtn) {
                        addToCartBtn.disabled = true;
                        addToCartBtn.innerHTML = 'Add to Cart';
                    }

                    // Reset BYM full state
                    if (bymSection) {
                        bymSection.classList.remove('bym--full');
                    }

                    // Reset progress bar
                    if (progressFill) {
                        progressFill.style.width = '0px';
                    }

                    progressNodes.forEach(node => node.classList.remove('active'));
                    progressLabels.forEach(label => label.classList.remove('active'));

                    // Collapse mobile cart
                    if (cartWrap) {
                        cartWrap.classList.remove('is-expanded');
                    }

                    // Reset motivator
                    updateMotivatorMessage();
                }

                // --- BYM Cart Submit Handler ---
                document.body.addEventListener('click', function (e) {
                    const submitBtn = e.target.closest('.bym--cart__add-to-cart');
                    if (submitBtn) {
                        e.preventDefault();
                        // Get line item property from last filled tier
                        const lastLineItemProp = getLastFilledTierLineItemProp();
                        // Collect all items to add
                        const itemsToAdd = [];
                        const tiers = document.querySelectorAll('.bym--cart__tier');
                        tiers.forEach(tierElem => {
                            const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                            if (tierProduct && tierProduct.innerHTML.trim() !== '') {
                                const productData = tierProduct.__productData;
                                if (productData) {
                                    const variantId = productData.selected_or_first_available_variant ? productData.selected_or_first_available_variant.id : null;
                                    if (variantId) {
                                        let properties = {};
                                        if (lastLineItemProp) properties[lastLineItemProp] = true;
                                        itemsToAdd.push({
                                            id: variantId,
                                            quantity: 1,
                                            properties: Object.keys(properties).length ? properties : undefined
                                        });
                                    }
                                }
                            }
                        });
                        if (itemsToAdd.length === 0) return;
                        // Add to cart
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                items: itemsToAdd
                            })
                        }).then(res => res.json()).then(() => {
                            resetBYMBundle();

                            // Disable BYM Add to Cart button and reset its text
                            const addToCartBtn = document.querySelector('.bym--cart__add-to-cart');
                            if (addToCartBtn) {
                                addToCartBtn.disabled = true;
                                // Remove all child nodes and set only the text
                                addToCartBtn.innerHTML = 'Add to Cart';
                            }
                            // Open cart drawer
                            const cartDrawer = document.querySelector('.js-cart-drawer');
                            if (cartDrawer) {
                                cartDrawer.classList.add('is-open');
                                document.body.classList.add('cart-drawer-open');
                            }
                            // Optionally, you can also redirect to the cart page
                            // window.location.href = '/cart';
                        }).catch(err => {
                            console.log('Error adding to cart:', err);
                        });
                    }
                });

                // Close BYM cart when clicking outside on mobile
                // document.addEventListener('click', function(e) {
                //   const cartWrap = document.querySelector('.js-bym-cart-wrap');
                //   const cartToggle = document.querySelector('.js-bym-cart-toggle');
                //   if (!cartWrap || !cartWrap.classList.contains('is-expanded')) return;
                //   // Only run on mobile
                //   if (window.innerWidth > 900) return;
                //   const isCart = cartWrap.contains(e.target);
                //   const isToggle = cartToggle && cartToggle.contains(e.target);
                //   if (!isCart && !isToggle) {
                //     cartWrap.classList.remove('is-expanded');
                //   }
                // });
            });

            // Close BYM cart when clicking the exit overlay
            document.body.addEventListener('click', function (e) {
                const exitBtn = e.target.closest('.bym--cart__exit');
                if (exitBtn) {
                    const cartWrap = document.querySelector('.js-bym-cart-wrap');
                    if (cartWrap) {
                        cartWrap.classList.remove('is-expanded');
                    }
                    return;
                }
            });

            // Helper: get last filled tier and its discount/property
            function getLastFilledTierInfo() {
                const tiers = Array.from(document.querySelectorAll('.bym--cart__tier'));
                let lastIndex = -1;
                let discount = 0;
                let dollarDiscount = 0;
                let lineItemProp = '';
                tiers.forEach((tierElem, idx) => {
                    const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                    if (tierProduct && tierProduct.innerHTML.trim() !== '') {
                        lastIndex = idx;
                    }
                });
                if (lastIndex >= 0) {
                    const tierElem = tiers[lastIndex];
                    const discountEl = tierElem.querySelector('.bym--cart__discount-percentage-off');
                    const dollarEl = tierElem.querySelector('.bym--cart__discount-dollar-off');
                    const lineItemEl = tierElem.querySelector('.bym--cart__line-item-property');
                    if (discountEl && discountEl.textContent.trim() !== '') {
                        discount = parseFloat(discountEl.textContent.trim()) || 0;
                    } else if (dollarEl && dollarEl.textContent.trim() !== '') {
                        dollarDiscount = parseFloat(dollarEl.textContent.replace(/[^\d.]/g, '')) || 0;
                    }
                    if (lineItemEl && lineItemEl.textContent.trim() !== '') {
                        lineItemProp = lineItemEl.textContent.trim();
                    }
                }
                return {
                    discount,
                    dollarDiscount,
                    lineItemProp
                };
            }

            // Helper: get discount from a tier element
            function getTierDiscountInfo(tierElem) {
                let discount = 0;
                let dollarDiscount = 0;
                const discountEl = tierElem.querySelector('.bym--cart__discount-percentage-off');
                const dollarEl = tierElem.querySelector('.bym--cart__discount-dollar-off');
                if (discountEl && discountEl.textContent.trim() !== '') {
                    discount = parseFloat(discountEl.textContent.trim()) || 0;
                } else if (dollarEl && dollarEl.textContent.trim() !== '') {
                    dollarDiscount = parseFloat(dollarEl.textContent.replace(/[^\d.]/g, '')) || 0;
                }
                return {
                    discount,
                    dollarDiscount
                };
            }

            // Helper: get line item property from last filled tier
            function getLastFilledTierLineItemProp() {
                const tiers = Array.from(document.querySelectorAll('.bym--cart__tier'));
                let lastIndex = -1;
                let lineItemProp = '';
                tiers.forEach((tierElem, idx) => {
                    const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                    if (tierProduct && tierProduct.innerHTML.trim() !== '') {
                        lastIndex = idx;
                    }
                });
                if (lastIndex >= 0) {
                    const tierElem = tiers[lastIndex];
                    const lineItemEl = tierElem.querySelector('.bym--cart__line-item-property');
                    if (lineItemEl && lineItemEl.textContent.trim() !== '') {
                        lineItemProp = lineItemEl.textContent.trim();
                    }
                }
                return lineItemProp;
            }

            /* ================================
               BYM Progress Bar
            ================================ */

            (() => {
                // --- DOM getters ---
                const tiers = () => document.querySelectorAll('.bym--cart__tier');
                const tierProductContainers = () =>
                    document.querySelectorAll('.bym--cart__tier-product');

                const progressFill = document.querySelector('.bym--cart__progress-fill');
                const progressLabelsWrap = document.querySelector('.js-bym-progress-labels');

                const fixedLabels = [null, '5% Off', '10% Off', '15% Off'];

                // --- Initialize progress labels ---
                function initProgressLabels() {
                    if (!progressLabelsWrap) return;

                    progressLabelsWrap.innerHTML = '';

                    tiers().forEach((_, idx) => {
                        const label = document.createElement('div');
                        label.className = 'bym--cart__progress-label';
                        label.dataset.tierIndex = idx;

                        if (fixedLabels[idx]) {
                            label.textContent = fixedLabels[idx];
                        }

                        progressLabelsWrap.appendChild(label);
                    });
                }

                // --- Update progress bar & nodes ---
                function updateProgressBar() {
                    const tierElems = tiers();
                    if (!progressFill || tierElems.length === 0) return;

                    let filledCount = 0;

                    tierProductContainers().forEach(container => {
                        if (container.innerHTML.trim() !== '') filledCount++;
                    });

                    const nodes = Array.from(
                        document.querySelectorAll('.bym--cart__progress-node')
                    );

                    nodes.forEach((node, i) => {
                        node.classList.toggle('active', i < filledCount);
                    });

                    const bar = document.querySelector('.bym--cart__progress-bar');
                    const fill = progressFill;

                    if (!bar || filledCount === 0) {
                        fill.style.width = '0px';
                        return;
                    }

                    const activeNode = nodes[filledCount - 1];
                    if (!activeNode) return;

                    const barRect = bar.getBoundingClientRect();
                    const nodeRect = activeNode.getBoundingClientRect();

                    const fillWidth =
                        nodeRect.left + nodeRect.width / 2 - barRect.left;

                    fill.style.width = `${fillWidth}px`;
                    bar.setAttribute(
                        'aria-valuenow',
                        Math.round((fillWidth / barRect.width) * 100)
                    );

                    // Labels
                    if (progressLabelsWrap) {
                        const labels = progressLabelsWrap.querySelectorAll(
                            '.bym--cart__progress-label'
                        );
                        labels.forEach((label, i) => {
                            label.classList.toggle('active', i < filledCount);
                        });
                    }
                }


                // Expose globally in case other scripts need it
                window.updateProgressBar = updateProgressBar;

                // --- Init on DOM ready ---
                document.addEventListener('DOMContentLoaded', () => {
                    initProgressLabels();
                    updateProgressBar();

                    // Observe changes inside each tier product container
                    const observer = new MutationObserver(updateProgressBar);
                    tierProductContainers().forEach(container => {
                        observer.observe(container, { childList: true, subtree: true });
                    });

                    // Optional: listen for BYM theme events (if they exist)
                    document.addEventListener('bym:cartUpdated', updateProgressBar);
                });
            })();


            // Fallback money formatter
            function formatMoney(amount, format) {
                if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                    return Shopify.formatMoney(amount, format || (window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}'));
                }
                // fallback: convert cents to dollars, add $
                var value = (amount / 100).toFixed(2);
                return `$${value}`;
            }
        }, { "../modules/getClosest": 1 }]
    }, {}, [2]);

    // Make sure this is at global scope
let cartExpanded = false;

// Disable default auto-expand
document.addEventListener('DOMContentLoaded', () => {
    const cartWrap = document.querySelector('.bym--cart.js-bym-cart-wrap');

    if (!cartWrap) return;

    // Intercept all add-to-cart clicks in BYM
    document.body.addEventListener('click', e => {
        const addBtn = e.target.closest('.bym-form__submit');
        if (!addBtn) return;

        // Prevent BYM from auto-expanding on intermediate adds
        const bymSection = document.querySelector('.bym');
        const tiers = document.querySelectorAll('.bym--cart__tier');
        const filledCount = Array.from(tiers).filter(tier =>
            tier.querySelector('.bym--cart__tier-product-item')
        ).length;

        // Only expand cart on last tier
        if (filledCount === tiers.length && !cartExpanded) {
            cartWrap.classList.add('is-expanded');
            cartExpanded = true;
        } else {
            cartWrap.classList.remove('is-expanded'); // collapse on intermediate adds
            cartExpanded = false;
        }
    });
});